import { Card, CardContent, Divider, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function SelectionSummaryCard({ rateCard, ruleSet, ruleSets = [] }) {
    const selectedRuleSets = getSelectedRuleSets()

    return (
        <Card>
            <CardContent sx={{ p: 2 }}>
                <Stack spacing={2}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2">Selected Rate Card</Typography>
                        <If value={rateCard}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Iconify
                                    icon="solar:user-id-broken"
                                    width={20}
                                    height={20}
                                    sx={{ color: "common.black", flexShrink: 0 }}
                                />
                                <Typography variant="body2" sx={{ fontSize: 16, fontWeight: 500 }} noWrap>
                                    {rateCard?.name}
                                </Typography>
                            </Stack>
                        </If>
                    </Stack>
                    <If value={selectedRuleSets.length > 0}>
                        <Divider sx={{ borderStyle: "dashed" }} />
                        <Stack spacing={1}>
                            <Typography variant="subtitle2">{ruleSetTitle()}</Typography>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Iconify
                                    icon="tabler:filter-cog"
                                    width={20}
                                    height={20}
                                    sx={{ color: "common.black", flexShrink: 0 }}
                                />
                                <Typography variant="body2" sx={{ fontSize: 16, fontWeight: 500 }} noWrap>
                                    {formatRuleSetNames()}
                                </Typography>
                            </Stack>
                        </Stack>
                    </If>
                </Stack>
            </CardContent>
        </Card>
    )

    function getSelectedRuleSets() {
        if (ruleSets.length) return ruleSets
        if (ruleSet) return [ruleSet]
        return []
    }

    function ruleSetTitle() {
        if (selectedRuleSets.length === 1) return "Selected Rule Set"
        return "Selected Rule Sets"
    }

    function formatRuleSetNames() {
        return selectedRuleSets.map(toRuleSetName).filter(Boolean).join(", ")
    }

    function toRuleSetName(item) {
        return item.name || item.id
    }
}
